export default __webpack_public_path__ + "static/media/Luigi 5, Badarà Sek e Basha.dd7b5dd8.jpg";